import { gql } from "@apollo/client";
import { OrderBy } from "../queryString";
import {
  PolicyVehicleExemptionSummary,
  policyVehicleExemptionSummaryFragment,
} from "../fragments/policyVehicleExemption";

export const GET_POLICY_VEHICLE_EXEMPTIONS = gql`
  query GetPolicyVehicleExemptions(
    $offset: Int = 0
    $limit: Int = 100
    $filter: policy_vehicle_exemption_bool_exp!
    $orderBy: [policy_vehicle_exemption_order_by!]
  ) {
    policyVehicleExemptions: policy_vehicle_exemption(
      where: $filter
      offset: $offset
      limit: $limit
      order_by: $orderBy
    ) {
      ...policyVehicleExemptionSummaryFragment
    }
    policyVehicleExemptionAggregate: policy_vehicle_exemption_aggregate(where: $filter) {
      aggregate {
        count
      }
    }
  }
  ${policyVehicleExemptionSummaryFragment}
`;

export interface GetPolicyVehicleExemptionsData {
  policyVehicleExemptions: PolicyVehicleExemptionSummary[];
  policyVehicleExemptionAggregate: {
    aggregate: {
      count: number;
    };
  };
}

export interface GetPolicyVehicleExemptionsVars {
  offset?: number;
  limit?: number;
  filter: GetPolicyVehicleExemptionsWhereFilter;
  orderBy?: PolicyVehicleExemptionsOrderBy[];
}

export interface GetPolicyVehicleExemptionsWhereFilter {
  end_at: { _is_null: true };
  _and?: GetPolicyVehicleExemptionsFilterCondition[];
  _or?: GetPolicyVehicleExemptionsFilterCondition[];
}

export interface GetPolicyVehicleExemptionsFilterCondition {
  registered_vehicle?: {
    license_plate?: { _ilike: string };
    state_code?: { _ilike: string };
  };
  license_plate_number_like?: { _ilike: string };
  license_plate_state_code_like?: { _ilike: string };
  _or?: GetPolicyVehicleExemptionsFilterCondition[];
}

export type PolicyVehicleExemptionsOrderBy = PolicyVehicleExemptionsOrderByBeginAt;

export interface PolicyVehicleExemptionsOrderByBeginAt {
  begin_at: OrderBy;
}
